module.exports = __webpack_public_path__ + "img/evaluationcount.fd954973.svg";